<template>
    <div class="partners-page">
        <!-- 添加与新闻页面相同的布局容器 -->
        <div style="color: #f8f9fa; font-size: 1px;">1</div>
        <div class="content-wrapper">
            <SimpleHeader title="戰略合作夥伴" subtitle="與全球頂尖企業共同創造卓越價值" />

            <!-- 數字統計 -->
            <section class="stats py-5 bg-light">
                <div class="container">
                    <div class="row g-4">
                        <div class="col-md-3 col-6 text-center">
                        <div class="stat-item p-3">
                            <div class="text-primary" style="font-weight: 800; font-size: 50px;">500+</div>
                            <p class="text-muted mb-0">合作企業</p>
                        </div>
                    </div>
                    <div class="col-md-3 col-6 text-center">
                        <div class="stat-item p-3">
                            <div class="text-primary" style="font-weight: 800; font-size: 50px;">150+</div>
                            <p class="text-muted mb-0">覆蓋國家</p>
                        </div>
                    </div>
                    <div class="col-md-3 col-6 text-center">
                        <div class="stat-item p-3">
                            <div class="text-primary" style="font-weight: 800; font-size: 50px;">99%</div>
                            <p class="text-muted mb-0">滿意度</p>
                        </div>
                    </div>
                    <div class="col-md-3 col-6 text-center">
                        <div class="stat-item p-3">
                            <div class="text-primary" style="font-weight: 800; font-size: 50px;">10年+</div>
                            <p class="text-muted mb-0">合作經驗</p>
                        </div>
                    </div>
                    </div>
                </div>
            </section>

            <!-- 合作夥伴展示 -->
            <section class="partners-showcase py-5" style="margin-top: 80px;">
                <h2 class="text-center mb-5">我們的合作夥伴</h2>
                <div class="row justify-content-center g-4">
                    <div class="col-12">
                        <el-row :gutter="30" justify="center">
                            <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="(partner, index) in partners" :key="index">
                                <div class="partner-card">
                                    <div>
                                        <img :src="`/api/file/download/${partner.logo}`"
                                            class="img-fluid" style="width: 100px;">
                                    </div>
                                    <div style="margin-left: 20px;">
                                        <div style="font-size: 20px; font-weight: bold;">
                                            {{ partner.name }}
                                        </div>
                                        <div style="margin-top: 10px; color: gray;">
                                            {{ partner.introduce }}
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </section>

            <!-- 合作流程 -->
            <section class="process bg-light py-5">
                <div class="container">
                    <h2 class="text-center mb-5">合作流程</h2>
                    <div class="row justify-content-center g-4">
                        <!-- 流程步骤列保持不变 -->
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            partners: [
                // { name: 'Partner 1', logo: '/images/partners/logo1.png' },
                // { name: 'Partner 2', logo: '/images/partners/logo2.png' },
                // 添加更多合作夥伴...
            ]
        }
    },
    mounted() {
        this.GetPartnersList()
    },

    methods: {
        //获取新闻动态的列表
        GetPartnersList() {
            this.$axios.get(`/partners/list?page=1&perPage=100000`)
                .then(res => {
                    for (let index = res.data.data.items.length - 1; index >= 0; index--) {
                        var data = {
                            name: res.data.data.items[index].name,
                            logo: res.data.data.items[index].image,
                            introduce: res.data.data.items[index].introduce,
                        };
                        this.partners.push(data);
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },

        formatDate(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
    }
}
</script>

<style scoped>
/* 添加布局相关样式 */
.partners-page {
    background: #f8f9fa;
}

.content-wrapper {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 1.5rem;
}

/* 调整标题样式 */
h2 {
    font-size: 40px;
    font-weight: 800;
    margin: 30px 0;
}

/* 合作伙伴卡片样式 */
.partner-card {
    padding: 36px;
    background: white;
    border-radius: 12px;
    margin: 16px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease;
}

.partner-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 12px rgba(0, 115, 255, 0.15);
}

/* 流程步骤样式 */
.process-step {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.step-icon {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    background: #0073ff !important;
}

@media (max-width: 768px) {
    .content-wrapper {
        padding: 0 1rem;
    }
    
    h2 {
        font-size: 32px;
    }
    
    .partner-card {
        padding: 24px;
        margin: 8px;
    }
}
</style>